import MenuBar from "./menu-bar";

export default MenuBar;
